import { type PlanStrategy } from './type';
import {
  FormatColumn,
  CappingColumn,
  KPIColumn,
  PlacementColumn,
  TgColumn,
  WebDeviceColumn,
  LanguageColumn,
  EstImpressionsColumn,
  EstClicksColumn,
  CTRColumn,
} from '../views/Plan/Grid/columns';

export const RTB: PlanStrategy = {
  KEY: 'RTB',
  TITLE: 'WEB plan',
  copyRow: (row) => {
    // comment?
    switch (row.kind) {
      case 'SMART':
        return {
          kind: row.kind,
          supplier: row.supplier,
          rate: row.rate,
          // apply_to: []
        };
      case 'SERVICE':
        return {
          kind: row.kind,
          supplier: row.supplier,
          unit: row.unit,
          gross_price: row.gross_price,
          provider_price: row.provider_price,
          naive: row.naive,
        };
      case 'MEDIA':
        return {
          kind: row.kind,
          supplier: row.supplier,
          unit: row.unit,
          gross_price: row.gross_price,
          client_price: row.client_price,
          provider_price: row.provider_price,
          naive: row.naive,
          // RTB fields
          language: row.language,
          web_device: row.web_device,
          placement: row.placement,
          format: row.format,
          // FIXME: fix in serializer or model? why do we return nulls to begin with
          tg: row.tg || '',
          kpi: row.kpi || '',
          capping: row.capping || '',
          // estimations
          ctr: row.ctr,
          est_impressions: row.est_impressions,
          est_clicks: row.est_clicks,
          // reach
          reach_composition: row.reach_composition,
          reach_frequency: row.reach_frequency,
        };
      default:
        throw Error(`Unexpected kind: ${row.kind}`);
    }
  },
  columns: [
    PlacementColumn,
    LanguageColumn,
    WebDeviceColumn,
    FormatColumn,
    TgColumn,
    KPIColumn,
    CappingColumn,
    EstImpressionsColumn,
    EstClicksColumn,
    CTRColumn,
  ],
  canImportPlan: false,
  canExportMediaReservation: true,
};
